"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAT_CLASS_PREFIX = exports.MATERIAL_ID = void 0;
// 内置的配置内容，外部不可更改

// 内置的物料库 id 号
var MATERIAL_ID = exports.MATERIAL_ID = '32';
var MAT_CLASS_PREFIX = exports.MAT_CLASS_PREFIX = 'trtc';